<template>
  <div class="container">
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
      <div style="margin-bottom: 18px">
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
          <el-form-item label="商品名称" prop="name">
            <el-input v-model="searchForm.name" placeholder="请输入商品名称" style="width: 232px" clearable></el-input>
          </el-form-item>
          <el-form-item label="商品编号" prop="goodsNo">
            <el-input v-model="searchForm.goodsNo" placeholder="请输入商品编号" style="width: 232px"></el-input>
          </el-form-item>
          <el-form-item label="商品类型" prop="type">
            <el-select v-model="searchForm.type" placeholder="请选择商品类型" style="width: 232px" filterable clearable>
              <el-option v-for="item in goods_types" :key="item.dictId" :label="item.dictName" :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="商品类目" prop="categoryIds">
            <el-cascader style="width: 232px" :options="categoryIds" v-model="searchForm.categoryIds"
                         popper-class="optionC" placeholder="请选择商品类目"
                         :props="{ checkStrictly: true, multiple: true, emitPath: false }" @change="onChangeCategory" collapse-tags
                         clearable></el-cascader>
          </el-form-item>
          <!-- <el-form-item label="是否上架" prop="status">
            <el-select v-model="searchForm.status" style="width: 232px" placeholder="请选择状态" clearable>
              <el-option v-for="item in dictionaries.sale_status" :key="item.dictId" :label="item.dictName"
                :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="关联标签" prop="tagId">
            <el-cascader style="width: 232px" :options="tagIds1" v-model="searchForm.tagLevel2" placeholder="请选择关联标签"
                         popper-class="optionC" @change="selectTag" :props="{ checkStrictly: true, multiple: true, emitPath: false }"
                         collapse-tags clearable></el-cascader>
          </el-form-item>
          <el-form-item label="发布时间" prop="createTimeStart">
            <el-date-picker v-model="value1" style="width: 232px" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <el-form-item style="margin-bottom:10px">
            <el-button type="primary" @click="fetchData('search')">查询</el-button>
            <el-button type="primary" plain @click="fetchData('reset')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <h3 style="font-weight: bold">
        列表数据
      </h3>
      <div class="btn-list">
        <div class="item">
          <el-radio-group v-model="radio1" @change="selectData">
            <el-radio-button label=" " border>全部({{
                countGroupByStatus.total
              }})</el-radio-button>
            <el-radio-button label="1">已上架({{ countGroupByStatus.upIng }})</el-radio-button>
            <el-radio-button label="0">已下架({{
                countGroupByStatus.downIng
              }})</el-radio-button>
          </el-radio-group>
        </div>
        <div class="item">
          <el-button type="primary" style="width: 120px" icon="el-icon-setting" @click="toPoster()">海报设置</el-button>
          <el-dropdown style="margin: 0 10px;">
            <el-button type="primary" style="width: 120px">批量上下架<i class="el-icon-arrow-down"></i></el-button>
            <el-dropdown-menu slot="dropdown" style="padding: 10px;">
              <!-- 1-上架，0-下架 -->
              <el-button type="primary" style="width: 120px" icon="el-icon-sell" @click="toUpGoods(1)">批量上架</el-button>
              <el-button type="danger" style="width: 120px" icon="el-icon-sold-out" @click="toUpGoods(0)">批量下架</el-button>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown style="margin: 0 10px 0 0">
            <el-button type="primary" style="width: 130px">批量修改标签<i class="el-icon-arrow-down"></i></el-button>
            <el-dropdown-menu slot="dropdown" style="padding: 10px">
              <el-button type="primary" style="width: 120px" icon="el-icon-edit" @click="toEditTag(3)">筛选标签</el-button>
              <el-button type="primary" style="width: 120px" icon="el-icon-edit" @click="toEditTag(2)">展示标签</el-button>
              <el-button type="primary" style="width: 120px" icon="el-icon-edit" @click="toEditTag(1)">营销标签</el-button>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" @click="deleteAlot" icon="el-icon-delete">批量删除</el-button>
          <el-button type="primary" @click="exportData()" icon="el-icon-upload2">批量导出</el-button>
        </div>
      </div>
      <div id="base-list">
        <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="page.totalNum"
                  layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
                  :current-page.sync="searchForm.pageNo" :page-size="searchForm.pageSize" @selection-change="onMultipleSelection"
                  @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
        </lb-table>
      </div>
    </div>
    <el-dialog title="温馨提示" :visible.sync="isD" width="518px" :append-to-body="true" top="calc(50vh - 100px)">
      <template>
        <div class="info" style="text-align: left">
          <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
          是否确认删除，删除后数据不可恢复！
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isD = false">取消</div>
          <div class="info-s" @click="submitD">确定</div>
        </div>
      </template>
    </el-dialog>
    <el-dialog title="温馨提示" :visible.sync="isLimit" width="518px" :append-to-body="true">
      <template>
        <div class="info">
          <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>您已新增上架商品
          {{ numberY }}
          个，已达新增上架商品上限，若想继续新增商品，请下架其中一个商品；
        </div>
        <div class="info-b">
          <span style="color: red">*</span> 若增加上架个数，请联系客服！
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isLimit = false">取消</div>
          <div class="info-s" @click="sLimit()">确定</div>
          <!-- <el-button type="primary" plain @click="isUp = false">取消</el-button>
          <el-button type="primary" @click="isUp = false">确定</el-button> -->
        </div>
      </template>
    </el-dialog>
    <el-dialog title="温馨提示" :visible.sync="isSup" width="518px" :append-to-body="true">
      <template>
        <div class="info" style="text-align: left">
          <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>当前商品已上架第三方平台，是否确认下架？
        </div>
        <div class="info-b">下架后所有平台都下架该商品！</div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isSup = false">取消</div>
          <div class="info-s" @click="sUpData">确定</div>
          <!-- <el-button type="primary" plain @click="isUp = false">取消</el-button>
          <el-button type="primary" @click="isUp = false">确定</el-button> -->
        </div>
      </template>
    </el-dialog>
    <el-dialog title="温馨提示" :visible.sync="isSdown" width="518px" :append-to-body="true">
      <template>
        <div class="info" style="text-align: left">
          <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>该商品五域系统已下架，平台不能再上架！
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isSdown = false">取消</div>
          <div class="info-s" @click="isSdown = false">确定</div>
          <!-- <el-button type="primary" plain @click="isUp = false">取消</el-button>
          <el-button type="primary" @click="isUp = false">确定</el-button> -->
        </div>
      </template>
    </el-dialog>
    <el-dialog title="海报设置" :visible.sync="isPoster" width="40%" :append-to-body="true">
      <template>
        <el-form label-width="80px" ref="posterForm" :model="posterForm" :rules="rulesP">
          <el-form-item label="模板">
            <el-select style="width: 100%" placeholder="请选择模板" v-model="posterForm.id" @change="changePoster">
              <el-option v-for="(item, index) in models" :key="item.id" :value="item.id" :label="item.label">

              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标题" prop="title">
            <el-input v-model="posterForm.title" placeholder="请输入标题" maxlength="20" show-word-limit></el-input>
          </el-form-item>
        </el-form>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isPoster = false">取消</div>
          <div class="info-s" @click="updatePoster">确定</div>
        </div>
      </template>
    </el-dialog>
    <!-- 批量上下架 -->
    <el-dialog :title="'批量' + upGoodsStatusText" :visible.sync="isUpPop" width="518px" :append-to-body="true"
               top="calc(50vh - 100px)">
      <template>
        <div class="info" style="text-align: left">
          <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
          是否确认{{ upGoodsStatusText + selectionGoods.length }}个商品？
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isUpPop = false">取消</div>
          <div class="info-s" @click="submitUpGoods">确定</div>
        </div>
      </template>
    </el-dialog>
    <el-dialog title="批量修改筛选标签" :visible.sync="isTag" width="40%" :append-to-body="true">
      <template>
        <div>
          <div style="margin-bottom:20px;margin-left:20px;font-weight: bold;color: #2D46EE;">选择标签</div>
          <el-form label-width="80px">
            <el-form-item :label="item.label" v-for="(item, index) in tagIds1" :key="index">
              <el-select style="width: 100%" :placeholder="'请选择' + item.label + '(可多选)'" multiple v-model="Tag[index]"
                         @change="selectT($event, index)">
                <el-option v-for="(item, index) in item.children" :key="item.value" :value="item.value"
                           :label="item.label">

                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="月份">
              <el-select style="width: 100%" placeholder="请选择月份（可多选）" multiple v-model="tagForm.month">
                <el-option v-for="(item, index) in T1" :key="item.value" :value="item.value" :label="item.label">

                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="节日">
              <el-select style="width: 100%" placeholder="请选择节日（可多选）" multiple v-model="tagForm.birty">
                <el-option v-for="(item, index) in T2" :key="item.value" :value="item.value" :label="item.label">

                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="送礼名义">
              <el-select style="width: 100%" placeholder="请选择送礼名义（可多选）" multiple v-model="tagForm.honer">
                <el-option v-for="(item, index) in T3" :key="item.value" :value="item.value" :label="item.label">

                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="地域">
              <el-select style="width: 100%" placeholder="请选择送礼名义（可多选）" multiple v-model="tagForm.area">
                <el-option v-for="(item, index) in T4" :key="item.value" :value="item.value" :label="item.label">

                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="人群">
              <el-select style="width: 100%" placeholder="请选择人群（可多选）" multiple v-model="tagForm.people">
                <el-option v-for="(item, index) in T5" :key="item.value" :value="item.value" :label="item.label">

                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="性别">
              <el-select style="width: 100%" placeholder="请选择性别（可多选）" multiple v-model="tagForm.sex">
                <el-option v-for="(item, index) in T6" :key="item.value" :value="item.value" :label="item.label">

                </el-option>
              </el-select>
            </el-form-item> -->
          </el-form>
        </div>
        <div>
          <div style="margin-bottom:10px;margin-left:20px;font-weight: bold;color: #2D46EE;">已选标签</div>
          <div style="
                                width: 97%;
                                min-height: 150px;
                                background: #F5F6FA;
                                margin-left:20px;
                                opacity: 1;">
            <div style="padding:10px 10px">
              <el-tag v-for="(item, index) in selectTagS" :key="index" :type="item.type" effect="dark" closable
                      @close="closeTag(item, index)" style="margin-right:10px;margin-top:10px">
                {{ item.name }}
              </el-tag>
            </div>

          </div>
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isTag = false">取消</div>
          <div class="info-s" @click="upTags()">确定</div>
          <!-- <el-button type="primary" plain @click="isUp = false">取消</el-button>
          <el-button type="primary" @click="isUp = false">确定</el-button> -->
        </div>
      </template>
    </el-dialog>
    <!-- 展示标签-->
    <el-dialog title="批量修改展示标签" :visible.sync="isTagStore" width="40%" :append-to-body="true">
      <template>
        <div>
          <div style="margin-bottom: 20px; margin-left: 20px; font-weight: bold; color: #2D46EE">选择标签</div>
          <el-form label-width="80px">
            <el-form-item v-for="(item, index) in tagIds1Show" :label="item.label" :key="index">
              <el-select v-model="Tag[index]" style="width: 100%" :placeholder="`请选择${item.label}(可多选)`" multiple @change="selectT($event, index)">
                <el-option v-for="it in item.children" :key="it.value" :value="it.value" :label="it.label"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <div style="margin-bottom: 10px; margin-left: 20px; font-weight: bold; color: #2D46EE">已选标签</div>
          <div style="width: 97%;min-height: 150px;background: #F5F6FA;margin-left: 20px;opacity: 1">
            <div style="padding: 10px">
              <el-tag v-for="(item, index) in selectTagS" :key="index" :type="item.type" effect="dark" closable @close="closeTag(item, index)" style="margin: 10px 10px 0 0;">{{ item.name }}</el-tag>
            </div>
          </div>
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isTagStore = false">取消</div>
          <div class="info-s" @click="upTags()">确定</div>
        </div>
      </template>
    </el-dialog>
    <!--营销标签-->
    <el-dialog title="批量修改营销标签" :visible.sync="isTagMarket" width="40%" :append-to-body="true">
      <template>
        <div>
          <el-form label-width="80px">
            <el-form-item label="选择标签">
              <el-select v-model="tagMarketingsT" ref="refTag" style="width: 442px" placeholder="请选择标签(可多选)" @change="changeD($event)" @visible-change="changeTag($event)" multiple>
                <el-option v-for="(item, i) in tagMarketings" :key="i" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isTagMarket = false">取消</div>
          <div class="info-s" @click="upTags()">确定</div>
        </div>
      </template>
    </el-dialog>
    <el-dialog :title="titleU" :visible.sync="isU" width="518px" :append-to-body="true" custom-class="infoI"
               top="calc(50vh - 100px)">
      <template>
        <div class="info" style="text-align: left">
          <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>{{ contentU }}
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isU = false">取消</div>
          <div class="info-s" @click="updateUp">确定</div>
        </div>
      </template>
    </el-dialog>
    <el-dialog title="下架提示" :visible.sync="isU1" width="518px" :append-to-body="true" custom-class="infoI"
               top="calc(50vh - 100px)">
      <template>
        <div class="info" style="text-align: left">
          <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>该商品下架，礼包商品<span
            v-if="gifts.length != 0">【</span>
          <span v-for="(item, index) in gifts" :key="index" style="color: red"><span v-if="index > 0"
                                                                                     style="color: red">、</span>{{ item }}</span>
          <span v-if="gifts.length != 0">】</span>也会下架，是否确认下架？
          </span>
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isU1 = false">取消</div>
          <div class="info-s" @click="updateUp">确定</div>
        </div>
      </template>
    </el-dialog>
    <el-dialog title="同步" :visible.sync="isAs" width="518px" :append-to-body="true" custom-class="infoI"
               top="calc(50vh - 100px)">
      <template>
        <div class="info" style="text-align: left">
          <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>商品信息会被五域系统商品信息覆盖，无法撤回，是否同步?
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isAs = false">取消</div>
          <div class="info-s" @click="updateAs">确定</div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script >
import LbTable from '../../../components/lb-table/lb-table'
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import Label from '../components/label.vue'
import ModifyState from '../components/ModifyState.vue'
import mixinsGiftlist from '../mixins/mixinsGiftlist.js'
const tagTypeText = { 1: "营销", 2: "展示", 3: "筛选" }
const tagURL = {
  1: 'goods/changeTagsMarketingInfo',
  2: 'goods/changeTagsStoreInfo',
  3: 'goods/changeTagsInfo',
}
export default {
  mixins: [mixinsGiftlist],
  components: {
    Label,
    LbTable,
    breadcrumbTop,
    ModifyState,
    breadcrumbSearch
    // BaseList
  },
  data() {
    return {
      value1: [],
      isUpPop: false,
      upGoodsStatus: '',
      upGoodsStatusText: '',
      isAs: false,
      gifts: [],
      isU1: false,
      titleU: '上架提示',
      contentU: '',
      isU: false,
      uId: '',
      uStatus: '',
      isD: false,
      tagForm: {
        month: [],
        birty: [],
        honer: [],
        area: [],
        people: [],
        sex: [],
      },
      pageNo: 1,
      pageSize: 10,
      tagList: [],
      totalNum: 0,
      name: '',
      isTag: false,
      isTagMarket: false,
      isTagStore: false,
      isSdown: false,
      isSup: false,
      isLimit: false,
      radio1: ' ',
      isUp: 'up',
      tagType: '',
      searchList: {
        list: [
          { title: '商品列表', path: '', type: '0' },
          { title: '数据筛选', path: '', type: '1' }
        ]
      },
      shopLists: [

      ],
      title: '批量上架',
      isShow: false,
      GoodsExportLoading: false,
      goods_types: [
        {
          dictId: '1',
          dictName: '普通商品'
        },
        {
          dictId: '3',
          dictName: '赠品'
        },
        // {
        //   dictId: '2',
        //   dictName: '积分商品'
        // },
        // {
        //   dictId: '4',
        //   dictName: '虚拟商品'
        // },
      ],
      dataList: {
        list: [
          { title: '商品管理', path: '', type: '0' },
          { title: '商品列表', path: '', type: '1' }
        ]
      },
      searchForm: {
        name: '', // 	否 	string 	商品名称
        platformGoodsNo: '', // 	否 	string 	商品编号
        categoryIds: [], // 	否 	int 	类目id（数据来源：接口 - /order/comm/commodityCategory/commList）
        type: '', // 	否 	int 	类型（1：普通商品；2：虚拟商品；3：赠品；字典：goods_type）
        status: '', // 	否 	int 	状态（字典：sale_status）
        origin: '',//来源
        pageNo: 1,
        pageSize: 10,
        goodsNo: '',
        tagLevel2: [],
        createTimeStart: '',
        createTimeEnd: '',
      },
      models: [
        {
          id: 1,
          label: '普通商品'
        },
        {
          id: 2,
          label: '秒杀商品'
        },
        // {
        //   id: 3,
        //   label: '模板三'
        // }
      ],
      tagIds1: [],
      tagIdsShow: [],
      tagIds1Show: [],
      tagIds2Show: [],
      tagIds: [
        {
          id: '1',
          label: '月份',
          children: [
            {
              id: '21',
              label: '一月'
            },
            {
              id: '22',
              label: '二月'
            },
            {
              id: '23',
              label: '三月'
            },
          ]
        },
        {
          id: '2',
          label: '节日',
          children: [
            {
              id: '32',
              label: '情人节'
            },
            {
              id: '34',
              label: '七夕节'
            },
            {
              id: '35',
              label: '中秋节'
            },
          ]
        },
      ],
      tags: [
        { type: 'primary', label: '十月' },
        { type: 'primary', label: '二月' },
        { type: 'primary', label: '少年' },
        { type: 'primary', label: '老人' },
        { type: 'primary', label: '男' }
      ],
      currentStatus: 100, // 当前列表状态
      groupByStatus: { // 数据切换
        totalCount: 100, // 全部
        onSaleCount: 200, // 上架中商品
        offSaleCount: 300 // 已下架商品
      },
      countGroupByStatus: { // 商品列表数量统计

        total: 0,
        upIng: 0,
        downIng: 0
      },
      // 数据列表
      list: [],
      loading: false,
      categoryList: [], // 目类列表
      brandList: [], // 品牌
      originList: [
        {
          id: 1,
          name: '平台上架'
        },
        {
          id: 2,
          name: '五域上架'
        },
      ],//来源列表
      categoryIds: [],
      columnsT: [
        { label: '标签名称', prop: 'tagName', minWidth: '120', align: 'center' },
        {
          label: '排序', prop: 'sort', minWidth: '140', align: 'center'
        },
        {
          label: '状态', prop: 'statusLabel', minWidth: '120',
          render: (h, scope) => {
            let vv = ''
            if (scope.row.statusLabel == '启用') {
              vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:start;"><div style="width: 10px;height: 10px;background: #13CE4B;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                <div>{scope.row.statusLabel}</div>
              </p>
            } else {
              vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:start;"><div style="width: 10px;height: 10px;background:  #F63C56;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                <div>{scope.row.statusLabel}</div>
              </p>
            }
            return (
                <div> {vv}</div>
            )
          }
        },
        {
          label: '操作',
          minWidth: '100',
          align: 'center',
          render: (h, scope) => {
            return (
                <div>
                  <el-switch
                      onChange={() => { this.isUpTag(scope.row) }}

                      v-model={scope.row.checkedL}
                      active-color="#2D46EE"
                      inactive-color="#EBEEFA">
                  </el-switch>
                  {/* <p class={scope.row.status === 1 ? 'success' : 'danger'}>{scope.row.statusLabel}</p> */}
                </div>
            )
          }
        },

      ],
      columns: [
        { type: 'selection', minWidth: '80', fixed: 'left' },
        {
          label: '排序', prop: 'sort', minWidth: '100', align: 'center'
        },
        {
          label: '商品信息',
          width: '300',
          render: (h, scope) => {
            return (
                <div style="display:flex;">
                  <el-image style="width:64px;height:64px;margin-right:8px;" src={scope.row.mainImageArr[0]} preview-src-list={scope.row.mainImageArr} lazy></el-image>
                  <div style="text-align:left;flex:1;">
                    <div style="width:100%;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;text-overflow:ellipsis;overflow:hidden;">
                      {scope.row.name}
                    </div>
                    <p>商品编号：{scope.row.goodsNo}</p>
                  </div>
                </div>
            )
          }
        },
        { label: '商品类型', prop: 'typeLabel', minWidth: '90' },
        { label: '商品类目', prop: 'categoryLabel', minWidth: '120' },
        {
          label: '商品价格', prop: 'marketPrice', minWidth: '100',
          render: (h, scope) => {
            return (
                <div>{scope.row.minPrice}~{scope.row.maxPrice}</div>
            )
          }
        },



        { label: '商品库存', prop: 'stock', minWidth: '90' },
        {
          label: '关联标签', prop: 'tags', minWidth: '100',
        },
        { label: '发布时间', prop: 'createTime', width: '170' },

        {
          label: '是否上架',
          minWidth: '100',
          render: (h, scope) => {
            return (
                <div>
                  <el-switch
                      onChange={() => { this.isUpShop(scope.row, scope.$index) }}
                      active-text="是"
                      inactive-text="否"
                      v-model={scope.row.statusL}
                      active-color="#2D46EE"
                      inactive-color="#EBEEFA">
                  </el-switch>
                  {/* <p class={scope.row.status === 1 ? 'success' : 'danger'}>{scope.row.statusLabel}</p> */}
                </div>
            )
          }
        },
        {
          label: '操作',
          minWidth: '130',

          renderHeader: (h, scope) => {
            return (
                <div>
                  <span >操作</span>
                </div>
            )
          },
          render: (h, scope) => {
            return (
                <div>
                  <span style='color:#2D46EE;cursor:pointer;' onClick={() => { this.toOtherPages('shopEdit', scope.row, 'edit') }}>查看/编辑</span>
                  <span style='color:#2D46EE;cursor:pointer;margin-left:10px' onClick={() => { this.synchronous(scope.row) }}>同步</span>
                </div>
            )
          }
        }],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      dialog: { visible: false, title: '编辑', type: '', row: {}, list: [], batch: false, titleArr: [] },
      dictionaries: { // 字典数据
        sale_status: [], // 状态
        goods_type: [] // 商品类型
      },
      selectionGoods: [], // 选 中 商品
      parArray: [],// 按钮权限
      numberY: 0,
      surNum: 0,
      cRow: {},
      pageNo: 1,
      pageSize: 10,
      psGoodsIds: [],
      searchFormT: {
        tagName: '',
        status: '',
        createdTimeStart: "",
        createdTimeEnd: '',
        pageNo: 1,
        pageSize: 1000000
      },
      T1: [],
      T2: [],
      T3: [],
      T4: [],
      T5: [],
      T6: [],
      Tag: [],
      tagIds2: [],
      selectTagS: [],
      tagMarketing: [],
      tagMarketings: [],
      tagMarketingsT: [],
      goodsNo: '',
      isSelect: false,
      isPoster: false,
      posterForm: {
        id: '',
        title: ''
      },
      rulesP: {
        id: [
          { required: true, message: '请选择模板', trigger: 'change' },
        ],
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' },

        ]
      }

    }
  },
  mounted() {

  },
  watch: {

    Tag: {
      handler(newVal, oldVal) {
        // console.log(newVal)
      },
      immediate: true,
      deep: true,// 为true，表示深度监听，这时候就能监测到a值变化

    }
  },
  created() {

    // this.getCategoryList()
    // this.getTagList()
    // this.fetchData()
    // this.getPlatform()
    // this.getPlatformInfo()
    // this.getTList()

  },
  beforeRouteEnter(to, from, next) {
    if (from.name == 'shopEdit') {
      next(vm => {
        vm.getCategoryList();
        vm.getTagList()
        vm.getTagListShow()
        vm.fetchData()
      });
    } else {
      next(vm => {
        vm.getCategoryList();
        vm.getTagList()
        vm.getTagListShow()
        vm.fetchData()
      });
    }
  },
  methods: {
    // 批量上架
    toUpGoods(status) {
      if (this.selectionGoods.length == 0) {
        this.$message.warning('请选择商品')
        return
      } else {
        // console.log('selectionGoods', this.selectionGoods)
        this.isUpPop = true
        this.upGoodsStatus = status
        //1-上架，0-下架
        if (status == 1) {
          this.upGoodsStatusText = "上架"
        } else if (status == 0) {
          this.upGoodsStatusText = "下架"
        }
      }
    },
    submitUpGoods() {
      this.isUpPop = false
      let idList = this.selectionGoods.map(e => (e.id))
      let data = {
        idList,
        status: this.upGoodsStatus
      }
      this.axios.post('/goods/goodsUpDownBatch', data).then(res => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.fetchData()
        }
      })
    },
    changePoster(e) {
      this.getPoster(e)
    },
    updatePoster() {
      this.$refs['posterForm'].validate((valid) => {
        if (valid) {
          this.axios.post('/goods/editPosterTitle', this.posterForm).then(res => {
            if (res.code == 0) {
              this.$message.success('设置成功')
              this.isPoster = false

            }
          })

        }
      })
    },
    toPoster() {
      this.isPoster = true
      this.getPoster(1)
    },
    getPoster(id) {
      this.axios.post('/goods/getPosterTitle', {
        id: id,
      }).then(res => {
        if (res.code == 0) {
          this.posterForm.id = id
          this.posterForm.title = res.data
        }
      })
    },
    synchronous(val) {
      this.isAs = true
      this.goodsNo = val.goodsNo
    },
    updateAs() {
      let data = {
        goodsNo: this.goodsNo,
      }
      this.axios.post('/goods/syncSingle', data).then(res => {
        if (res.code == 0) {
          this.$message.success('同步成功')
          this.isAs = false
          this.fetchData()
        }
      })
    },
    updateUp() {
      let data = {
        id: this.uId,
        status: this.uStatus
      }
      this.axios.post('/goods/goodsUpDown', data).then(res => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.isU = false
          this.isU1 = false
          this.fetchData()
        } else {
          this.isU = false
          this.isU1 = false
          this.fetchData()
        }
      })
    },
    closeTag(e, index) {
      this.selectTagS.splice(index, 1)
      // console.log(e, this.Tag)
      this.Tag.forEach(item => {
        for (let i = 0; i < item.length; i++) {
          if (item[i] == e.id) {
            item.splice(i, 1)
          }
        }
      })
      for (let i = 0; i < this.Tag.length; i++) {
        let arr = []
        this.Tag[i].forEach(item => {
          arr.push(item)
        })
        this.$set(this.Tag, i, arr)
      }
      this.$forceUpdate()
    },
    selectT(e, index) {
      // console.log(e, this.Tag, index)
      // console.log(this.tagIds2)
      let temIds = []
      switch (this.tagType) {
        case 2:
          temIds = this.tagIds2Show
          break;
        case 3:
          temIds = this.tagIds2
          break;
        default:
      }
      this.selectTagS = []
      this.Tag.forEach(item => {
        item.forEach(itm => {
          temIds.forEach(it => {
            if (itm == it.id) {
              let obj = {
                id: it.id,
                name: it.name,
                selected: 1
              }
              this.selectTagS.push(obj)
            }
          })
        })
      })
      // console.log(this.selectTagS)
    },
    selectTag(e) {
      // console.log(e)
    },
    deleteAlot() {
      if (this.selectionGoods.length == 0) {
        this.$message.warning('请选择商品')
        return
      } else {
        this.isD = true
      }

    },
    submitD() {
      this.psGoodsIds = []
      this.selectionGoods.forEach(item => {
        this.psGoodsIds.push(item.id)
      })
      let data = {
        ids: this.psGoodsIds
      }
      this.axios.post('goods/delete', data)
          .then(res => {
            // console.log(res)
            if (res.code == 0) {
              this.$message.success('删除成功')
              this.isD = false
              this.fetchData()
            }
          })
    },
    getTList() {
      this.axios.post('/tags/pageList', this.searchFormT)
          .then(res => {
            // console.log(res)
            // res.data.list.forEach(item => {
            //   if (item.status == true) {
            //     item.statusLabel = '启用'
            //     item.statusL = '禁用'
            //   } else {
            //     item.statusLabel = '禁用'
            //     item.statusL = '启用'
            //   }
            // })
            // this.tags = res.data.list;
            // this.page.totalNum = res.data.totalNum;
          })
    },
    changeD(e) {
      this.tagMarketing = [];
      this.tagMarketings.forEach(item => {
        this.tagMarketingsT.forEach(it => {
          if (item.id == it) {
            let obj = {
              id: item.id,
              name: item.name,
              selected: 1
            }
            this.tagMarketing.push(obj)
          }
        })
      });
    },
    changeTag(e) {
      this.tagMarketing = [];
      if (!e) {
        this.isSelect = true;
        this.tagMarketings.forEach(item => {
          this.tagMarketingsT.forEach(it => {
            if (item.id == it) {
              let obj = {
                id: item.id,
                name: item.name,
                selected: 1
              }
              this.tagMarketing.push(obj)
            }
          })
        });
      }
    },
    upTags() {
      // console.log(this.selectTagS, this.tagIds2)
      let arr = []
      this.selectTagS.forEach(item => [
        arr.push(String(item.id))
      ])

      let tags = []
      // 1-营销，2展示，3筛选
      let temTagIds = []
      switch (this.tagType) {
        case 1:
          temTagIds = this.tagMarketings;
          arr = this.tagMarketingsT;
          break;
        case 2:
          temTagIds = this.tagIds2Show
          break;
        case 3:
          temTagIds = this.tagIds2
          break;
        default:
      }
      // console.log(arr, this.tagIds2)
      temTagIds.forEach(item => {
        arr.forEach(itm => {
          if (item.id == itm) {
            let obj = {
              id: item.id,
              name: item.name,
              selected: 1
            }
            tags.push(obj)
          }
        })
      })
      let data = {
        ids: this.psGoodsIds,
        tag: tags,
        tagType: this.tagType
      }
      this.axios.post('/goods/changeTags', data).then(res => {
        if (res.code == 0) {
          this.$message.success('批量修改成功')
          this.isTag = false
          this.isTagStore = false
          this.isTagMarket = false
          this.fetchData()
        }
      })
    },
    isUpTag(row) {
      // console.log(row)
      let status = 0
      if (row.checked == 0) {
        status = 1
      } else {
        status = 0
      }
      let data = {
        id: row.id,
        status: status,
        psGoodsIds: this.psGoodsIds
      }
      this.axios.post('/psTag/updatePsTag', data).then(res => {
        if (res.code == 0) {
          this.$message.success('更改成功')
        }
      })
    },
    //修改标签
    editTag(val) {
      this.name = ''
      this.psGoodsIds = []
      // this.selectionGoods = []
      this.psGoodsIds = []
      this.pageNo = 1
      this.isTag = true
      // this.selectionGoods.push(val)

    },
    //批量修改标签
    toEditTag(tagType) {
      this.name = ''
      if (this.selectionGoods.length == 0) {
        this.$message.warning('请选择商品')
        return
      } else {
        // 1-营销，2展示，3筛选
        switch (tagType) {
          case 1:
            this.isTagMarket = true;
            break;
          case 2:
            this.isTagStore = true;
            break;
          case 3:
            this.isTag = true;
            break;
          default:
        }
        this.tagType = tagType;
        // console.log(this.selectionGoods)
        // this.Tag[0] = ['23', '19']
        this.getTags(tagType)
      }
    },
    fetchData1(val) {
      if (val == 'reset') {
        this.pageNo = 1
        this.name = ''
      } else if (val == 'search') {
        this.pageNo = 1

      }

      this.getTags1()
    },
    getTags1() {
      let data = {
        psGoodsIds: this.psGoodsIds,
        name: this.name,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      this.axios.post('/psTag/tagePageList', data).then(res => {
        if (res.code == 0) {
          res.data.list.forEach(item => {
            if (item.status == 1) {
              item.statusLabel = '启用'
            } else {
              item.statusLabel = '禁用'
            }
            if (item.checked == 0) {
              item.checkedL = false
            } else {
              item.checkedL = true
            }
          })
          this.tagList = res.data.list
          this.totalNum = res.data.totalNum
        }
      })
    },
    getTags(tagType) {
      this.psGoodsIds = []
      this.selectionGoods.forEach(item => {
        this.psGoodsIds.push(item.id)
      })
      let data = {
        ids: this.psGoodsIds,
      }
      this.selectTagS = []
      this.Tag = []
      this.tagMarketingsT = []
      this.axios.post(tagURL[tagType], data).then(res => {
        if (res && res.code == 0) {
          // console.log(res.data)
          let arr = []
          if (tagType == 1) {
            this.tagMarketings = res.data.tagMarketing;
            let listSelected = this.tagMarketings.filter(e => e.selected == 1)
            this.tagMarketingsT = listSelected.map(e => e.id)
            return false;
          }
          let tags = res.data.tag || res.data.tagStore
          tags.forEach(item => {
            if (item.childTags) {
              item.childTags.forEach(itm => {
                if (itm.selected == 1) {
                  let obj = {
                    id: itm.id,
                    name: itm.name,
                    selected: 1
                  }
                  this.selectTagS.push(obj)
                }

                // arr.push(itm.id)
              })
            }
          })
          // 1-营销，2展示，3筛选
          let tagIdsTem = []
          switch (tagType) {
            case 1:
              this.isTagMarket = true;
              break;
            case 2:
              tagIdsTem = this.tagIds1Show;
              break;
            case 3:
              tagIdsTem = this.tagIds1;
              break;
            default:
          }
          tags.forEach(item => {
            for (let i = 0; i < this.tagIds1.length; i++) {
              if (item.id == this.tagIds1[i].value) {
                this.Tag[i] = []
                item.childTags.forEach(itm => {
                  if (itm.selected == 1) {
                    this.Tag[i].push(String(itm.id))
                  }

                })
              }
            }
          })
          // console.log(this.Tag)
        }
      })
    },
    // 获取展示标签
    getTagListShow() {
      this.tagIdsShow = [];
      this.axios.post('/tagPool/show/categoryList', {})
          .then(res => {
            res.data.forEach(item => {
              let obj = {
                value: item.dictId,
                label: item.dictName,
                children: []
              }
              this.tagIdsShow.push(obj)
            });
            this.getSecondTagShow()
          })
    },
    getSecondTagShow() {
      let data = {
        pageNo: 1,
        pageSize: 100000
      }
      this.axios.post('/tagPool/show/pageList', data).then(res => {
        this.tagIds2Show = res.data.list
        res.data.list.forEach(item => {
          item.id = `${item.id}`;
          item.label = item.name;
          this.tagIdsShow.forEach(it => {
            if (item.pid == it.value) {
              let obj = {
                value: item.id,
                label: item.label,
              }
              it.children.push(obj);
            }
          });
        });

        this.tagIds1Show = this.tagIdsShow
      })
    },
    sLimit() {
      this.isLimit = false
      this.fetchData()
    },
    getPlatformInfo() {
      this.axios.get('/sys/platformInfo', {}).then(res => {
        if (res.code == 0) {
          if (this.surNum == 0) {
            this.numberY = res.data.productCount
          }
        }
      })
    },
    sUpData() {
      let data = {
        id: this.cRow.id,
        type: 0
      }
      this.axios.post('/goods/upPsGoods', data).then(res => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.isSup = false
          this.fetchData()
        }
      })
    },
    isUpShop(row, index) {
      let status = 0
      // console.log(row)
      this.uId = row.id


      if (row.status == 1) {
        this.uStatus = 0
        this.titleU = '下架提示'
        // this.contentU = '当前商品已上架，是否确认下架？'
        this.list[index].statusL = true
        let data = {
          id: row.id,
          sku: '',
          status: '0'
        }
        this.axios.post('/goods/checkGoodsBindingGfit', data).then(res => {
          if (res.code == 0) {
            this.gifts = res.data || []
            if (this.gifts.length == 0) {
              this.isU = true
              this.contentU = '当前商品已上架，是否确认下架？'
            } else {
              this.isU1 = true
            }
          }
        })

      } else {
        this.isU = true
        this.uStatus = 1
        this.titleU = '上架提示'
        this.contentU = '当前商品已下架，是否确认上架？'
        this.list[index].statusL = false
      }
    },
    getPlatform() {
      this.axios.get('/sys/platformInfo', {}).then(res => {
        if (res.code == 0) {
          this.surNum = res.data.platformInfo.maxGoodsNum - res.data.productCount
        }
      })
    },
    toApply() {
      this.$router.push({
        name: 'shopApply',
        query: {}
      })
    },
    toAwait() {
      this.$router.push({
        name: 'pendingShop',
        query: {}
      })
    },
    exportData() {
      let params = {

      }
      let ids = []
      if (this.selectionGoods) {
        this.selectionGoods.forEach(item => {
          ids.push(item.id)
        })
      }

      params = Object.assign(params, this.searchForm)
      params.ids = ids
      this.axios.post('/goods/export', params).then((res) => {
        this.downloadlink(res.data)
        this.$message.success('操作成功！')
      }).catch((err) => {
        this.GoodsExportLoading = false
        // console.log(err)
      })
    },
    downloadlink(url) {
      const protocol = location.protocol
      let resultUrl = url
      if (protocol === 'https:') {
        resultUrl = url.replace(`http:`, `${protocol}`)
      }
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = resultUrl
      document.body.appendChild(iframe)
    },
    selectData() {
      if (this.radio1 == ' ') {
        this.searchForm.status = ''
        // this.radio1 = ''
      } else {
        this.searchForm.status = this.radio1
      }

      this.fetchData()
    },
    // 获取字典数据
    getDictionaries(type) {
      this.axios.get('/sys/dictByGroup', {
        params: {
          groupId: type
        }
      })
          .then(res => {
            // console.log(res)
            if (res.code == 0) {
              this.dictionaries[type] = res.data
            }
          })
    },
    add() {
      this.axios.get('/sys/platformInfo', {}).then(res => {
        if (res.code == 0) {
          if (this.surNum == 0) {
            this.isLimit = true
            this.numberY = res.data.productCount
          } else {
            this.isLimit = false
            this.$router.push({
              name: 'addGoodsCategory',
              query: {}
            })
          }
        }
      })
      // this.$router.push({
      //   name: 'addGoodsCategory',
      //   query: {}
      // })
    },
    changeUp(val) {
      this.isUp = val
    },
    //表格合并行和列
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      let pos = 0
      let len = this.shopLists.length
      for (let i = 0; i < len; i++) {
        const item = this.shopLists[i]
        if (i === 0) {
          item.$rows = 1
          pos = 0
        }
        if (i !== 0) {
          if (item.skuNo === this.shopLists[i - 1].skuNo) {
            item.$rows = 0
            this.shopLists[pos].$rows = this.shopLists[pos].$rows + 1
          } else {
            item.$rows = 1
            pos = i
          }
        }
      }
      if (columnIndex === 0) {
        return {
          rowspan: row.$rows,
          colspan: row.$rows ? 1 : 0,
        };
      }
    },
    getretailPrice(title, row) {
      this.dialog.visible = true
      if (title == 'retailPrice') {
        this.dialog.title = '零售价'
      } else if (title == 'stock') {
        this.dialog.title = '可用库存'
      } else {
        this.dialog.title = '销量'
      }
      this.dialog.width = '640px'
      this.dialog.type = title
      this.dialog.list = row.skuList
    },
    fetchData(type) {
      this.loading = true;
      if (type == 'reset') {
        //
        this.searchForm = {}
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
        this.searchForm.categoryIds = []
        this.value1 = []
        if (this.radio1 == ' ') {
          this.searchForm.status = ''
          // this.radio1 = ''
        } else {
          this.searchForm.status = this.radio1
        }
      }
      if (type == 'search') {
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      if (this.value1 && this.value1.length > 0) {
        this.searchForm.createTimeStart = this.value1[0];
        this.searchForm.createTimeEnd = this.value1[1];
      } else {
        this.searchForm.createTimeStart = ''
        this.searchForm.createTimeEnd = ''
      }
      // console.log(this.searchForm)
      this.axios.post('/goods/pageList', this.searchForm).then((res) => {
        if (res.code === 0) {
          res.data.list.forEach(e => {
            e.minPrice = Number(e.minPrice).toFixed(2)
            e.maxPrice = Number(e.maxPrice).toFixed(2)
            // e.stock = Number(e.stock)
            // e.soldNum = Number(e.soldNum)
            e.mainImageArr = []
            e.mainImageArr.push(e.image)
            // if (e.isMyOutput == 1) {
            //   e.isMyOutputLabel = '平台上架'
            // } else {
            //   e.isMyOutputLabel = '五域上架'
            // }
            // if (e.tagNames) {
            //   e.tagNames = e.tagNames
            // } else {
            //   e.tagNames = '-'
            // }
            // e.skuList.forEach(it => {
            //   it.skuNo = e.goodsNo + it.skuNo
            // })
            // e.statusL = false
            if (e.status == 1) {
              e.statusL = true
            } else {
              e.statusL = false
            }
          })

          this.list = res.data.list
          // console.log(this.list)
          this.page.totalNum = res.data.totalNum
        } else {
          console.log('goodsPageList - 失败', type)
        }
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
        // console.log(err)
      })
      this.getCountGroupByStatus()// 获取商品列表数量统计
      // this.getPlatform()
    },
    handleCurrentChange(currentChange) {
      this.searchForm.pageNo = currentChange
      this.fetchData()
    },
    handleSizeChange(sizeChange) {
      this.searchForm.pageSize = sizeChange
      this.fetchData()
    },
    handleCurrentChange1(currentChange) {
      this.pageNo = currentChange
      this.fetchData1()
    },
    handleSizeChange1(sizeChange) {
      this.pageSize = sizeChange
      this.fetchData1()
    },
    getButtonTreeDto() {
      // 获取权限设定
      this.limits = JSON.parse(sessionStorage.getItem('limit'))
      const params = this.limits.buttonTreeDto.filter(
          (item) => item.menuCode === 'companyCode'
      )
      params[0].buttonList.forEach((item) => {
        this.parArray.push(item.code)
      })
    },
    // 获取字典数据
    getDictionaries(type) {
      if (type && this.dictionaries[type].length > 0) { return }
      const params = { groupId: type }
      this.$api.dictionaries(params).then((res) => {
        this.dictionaries[type] = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取商品列表数量统计
    getCountGroupByStatus() {
      const params = {}
      this.axios.post('/goods/statistics', this.searchForm).then((res) => {
        this.countGroupByStatus = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    getCategoryList() {
      let data = {
        pageNo: 1,
        pageSize: 10000,
        // categoryName: '',
        // categoryNo: '',
        // status: null
      }
      this.axios.post('/category/pageList', data)
          .then(res => {
            // console.log(res)
            if (res.code == 0) {
              this.categoryIds = res.data.list
            }
          })
    },
    getTagList() {
      this.tagIds = []
      this.axios.post('/tagPool/filter/categoryList', {})
          .then(res => {
            res.data.forEach(item => {
              let obj = {
                value: item.dictId,
                label: item.dictName,
                children: []
              }
              this.tagIds.push(obj)
            })
            this.getSecondTag()
          })
    },
    getSecondTag() {
      let data = {
        pageNo: 1,
        pageSize: 100000
      }
      this.axios.post('/tagPool/filter/pageList', data)
          .then(res => {
            this.tagIds2 = res.data.list
            res.data.list.forEach(item => {
              item.id = String(item.id)
              item.label = item.name
              this.tagIds.forEach(itm => {
                if (item.pid == itm.value) {
                  let obj = {
                    value: item.id,
                    label: item.label,
                  }
                  itm.children.push(obj)
                }
              })
            })

            this.tagIds1 = this.tagIds
            // console.log(this.tagIds1)
          })
    },
    // 获取 品牌 列表
    getBrandList() {
      const params = { pageNo: 1, pageSize: 999 }
      this.$api.brandCommList(params).then((res) => {
        this.brandList = res.data.list
      }).catch((err) => {
        console.log(err)
      })
    },
    // 搜索 选择 类目
    onChangeCategory(val) {
      // this.search.classId = val[val.length -1]
      // console.log(val, this.search.classId)
    },
    // 切换当前列表
    onChangeList(state) {
      this.page = { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1 }
      this.currentStatus = state
      // if ( this.currentStatus === this.assignStatus.all) {}
      if (this.currentStatus === this.groupByStatus.totalCount) { this.fetchData('all') }
      if (this.currentStatus === this.groupByStatus.onSaleCount) { this.fetchData('up') }
      if (this.currentStatus === this.groupByStatus.offSaleCount) { this.fetchData('down') }
    },
    // 多选
    onMultipleSelection(val) {
      this.selectionGoods = val
    },
    // 上架、下架
    async operationStatus(type, row) {
      this.isShow = true
      if (type == 'up') {
        this.title = '批量上架'
      } else {
        this.title = '批量下架'
      }
      return
      // console.log(type, row)
      let msg = type === 'up' ? `是否上架商品, 是否继续?` : `是否下架商品, 是否继续?`
      const params = { ids: [] }
      const selectionId = []
      const titleArr = []
      const selectionGoods = this.selectionGoods
      selectionGoods.forEach(e => { selectionId.push(e.id) })
      if (row) {
        this.dialog.row = row
        params.ids.push(row.id)
        titleArr.push(row.name)
        msg = type === 'up' ? `是否上架【${row.name}】, 是否继续?` : `是否下架【${row.name}】, 是否继续?`
      } else {
        this.list.forEach(e => {
          selectionId.forEach(s => {
            if (e.id === s) {
              titleArr.push(e.name)
            }
          })
        })
        params.ids = selectionId

      }
      // console.log(selectionId.length, type, selectionId)
      if (params.ids.length === 0) { return this.$message({ type: 'error', message: '需要选择商品!' }) }

      if (type === 'up') {
        const findObj = selectionGoods.find(e => { return e.status === 1 })
        if (findObj) { return this.$message({ type: 'error', message: '已有商品上架!' }) }
      }
      if (type === 'down') {
        this.$api.giftListByGoodId(params.ids).then((res) => {
          if (res.data.length > 0) {
            this.giftListByGoodId = res.data
            return this.showModifyState(type, titleArr)
          } else {
            return this.onUpDownOperation(type, params, msg)
          }
        }).catch((err) => {
          // console.log(err)
        })
        // setTimeout(() => {}, 1000)
        const findObj = selectionGoods.find(e => { return e.status === 0 })
        // if (findObj) { return this.$message({ type: 'error', message: '已有商品下架!' }) }
      } else {
        this.onUpDownOperation(type, params, msg)
      }
    },
    onUpDownOperation(type, params, msg) {
      let operationFun
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        switch (type) {
          case 'up':
            operationFun = this.$api.goodsPutOn
            // this.column = columnConsumption
            break
            // 分配记录
          case 'down':
            operationFun = this.$api.goodsPutOff
            break
            // default:
        }
        operationFun(params).then((res) => {
          this.fetchData()
          this.$message({ type: 'success', message: '操作成功!' })
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    showModifyState(skuList, titleArr) {
      // console.log('showModifyState', skuList, titleArr)
      this.setCloseOrder = ''
      this.dialog.visible = true
      this.dialog.title = '下架提示'
      this.dialog.width = '640px'
      this.dialog.type = 'modifyState'
      // this.dialog.row = row
      this.dialog.titleArr = titleArr
      // this.dialog.list = row.skuList
      // this.cancelOrderId = row.orderId
      // console.log('getGoodCopySku', this.dialog.list)
    },
    // 根据商品id,获取礼包列表查询接口
    onGiftListByGoodId(ids) {
      // const params = { goodsIds: ids }
      this.$api.giftListByGoodId(ids).then((res) => {
        // console.log(res)
        return res
      }).catch((err) => {
        // console.log(err)
        return res
      })
    },
    // 删除商品
    onGoodsDelete(row) {
      const msg = `此操作将删除【${row.name}】, 是否继续?`
      this.$confirm(msg, '提示', {
        title: '删除商品',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        const params = { id: row.id }
        this.$api.goodsDelete(params).then((res) => {
          this.fetchData()
          this.$message({ type: 'success', message: '操作成功!' })
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    toOtherPages(name, parameter, type) {
      this.$router.push({
        name,
        query: { id: parameter.id, type, oType: parameter.isMyOutput }
      })
    },
    // 获取 商品 KSU
    getGoodCopySku(skuList, row) {
      this.setCloseOrder = ''
      this.dialog.visible = true
      this.dialog.title = '复制SKU码'
      this.dialog.width = '640px'
      this.dialog.type = 'skuList'
      this.dialog.list = row.skuList
      // this.cancelOrderId = row.orderId
      // console.log('getGoodCopySku', this.dialog.list)
    },
    // 复制 KSU
    onCopySku(info) {
      // console.log('onCopySku', info)
      const t = this
      this.$copyText(info).then(
          function (e) {
            t.$message({
              type: 'success',
              message: '复制成功'
            })
          },
          function (e) {
            t.$message({
              type: 'warning',
              message: '复制失败'
            })
          }
      )
    },
    // 商品导出
    onGoodsExport() {
      this.GoodsExportLoading = true
      let params = {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        status: this.currentTab
      }
      params = Object.assign(params, this.searchForm)
      // 类目id
      const tempCategoryIdArr = [].concat(params.categoryId)
      if (tempCategoryIdArr && tempCategoryIdArr.length !== 0) {
        params.categoryId = tempCategoryIdArr[tempCategoryIdArr.length - 1]
      }
      for (const item in params) {
        if (typeof params[item] === 'string') {
          params[item] = params[item].trim()
          if (params[item] === '') { delete params[item] }
        }
      }
      this.$api.goodsExport(params).then((res) => {
        this.GoodsExportLoading = false
        this.downloadlink(res.data)
        this.$message.success('操作成功！')
      }).catch((err) => {
        this.GoodsExportLoading = false
      })
    }
  }
}
</script>
<style  lang="scss">
.el-tag--dark {
  background-color: #2D46EE;
  border-color: #2D46EE;
  color: #fff;
}

.optionC {
  .el-cascader-panel {
    .el-scrollbar:first-child {
      .el-checkbox {
        display: none;
      }
    }
  }
}

el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
  color: #2d46ee;
  font-weight: 700;
}

.el-cascader__suggestion-item.is-checked {
  color: #2d46ee;
  font-weight: 700;
}
</style>
<style scoped lang="scss">
@import "@/assets/styles/modifyState.scss";

.info {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 30px;
  color: #303033;
  opacity: 1;
  text-align: center;
}

.info-b {
  margin-left: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 40px;
  color: #303033;
  text-align: left;
}

.info-q {
  width: 124px;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
  border: 1px solid #909099;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #909099;
  margin-right: 18px;
  cursor: pointer;
}

.info-s {
  width: 126px;
  height: 40px;
  line-height: 40px;
  background: #2d46ee;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

::v-deep .el-switch__label {
  position: absolute;
  display: none;
  color: #fff;
}

/*打开时文字位置设置*/
::v-deep .el-switch__label--right {
  z-index: 1;
  right: 20px;
}

/*关闭时文字位置设置*/
::v-deep .el-switch__label--left {
  z-index: 1;
  left: 20px;
}

/*显示文字*/
::v-deep .el-switch__label.is-active {
  display: block;
}

::v-deep .el-switch .el-switch__core,
.el-switch .el-switch__label {
  width: 60px;
}

::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
  color: #2d46ee;
  background-color: #fff !important;
  border-color: #2d46ee;
  box-shadow: -1px 0 0 0 #2d46ee;
}

.dialog-search {
  margin-top: 4px;
}

.dialog-button {
  margin-top: 6px;
}

.dialog-pagination {
  margin-top: 20px;
  margin-bottom: 20px;
  float: right;
}

.platform {
  margin: 20px 20px;

  .el-radio {
    padding: 10px 10px;
  }
}

/deep/.hide-content {
  display: none !important;
}

//删除全页面按钮边框
// .el-button {
//   border: none;
// }
// 按钮
.btn-list {
  margin-bottom: 22px;
  display: flex;

  .item {
    flex: 1;

    &:last-child {
      text-align: right;

      .el-button {
        width: 120px;

        // color: #2d7edf;
        // border: 1px solid #2d7edf;
        &:last-child,
        .goods-export {
          color: #ffffff;
          // border: 1px solid #409eff;
        }
      }

      .el-button--warning {
        background-color: #ff9226;
      }

      .goods-export {
        color: #ffffff;
        // border: 1px solid #409eff;
      }
    }

    .el-button {
      height: 36px;
      line-height: 36px;
      padding-top: 0;
      padding-bottom: 0;
    }

    .is-disabled {
      background-color: #f4f4f5 !important;
      border: 1px solid #d3d4d6 !important;
      color: #909399 !important;
    }

    /deep/ .el-radio-button__inner {
      padding: 8px 20px;
    }
  }
}

.search-form {
  display: flex;
  flex-wrap: wrap;

  .el-form-item {
    /deep/ .el-form-item__label {
      width: 82px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }

    /deep/ .el-form-item__content {
      display: block;
      margin-left: 82px;

      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}

/deep/.el-scrollbar {
  height: 10px;
}

/deep/.el-scrollbar__bar.is-horizontal {
  height: 9px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
  display: inline-block;

  a {
    margin: 0 5px;
  }
}
</style>